import styled from 'styled-components'

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  width: fit-content;
`
